import { Link, useLocation } from "react-router-dom";
import { Home, MessageSquare, Target, LayoutDashboard, User } from "lucide-react";
import { motion } from "framer-motion";
import { useAuth } from "@/contexts/AuthContext";

const tabs = [
  { label: "Home", href: "/", icon: Home, state: { fromNav: true } },
  { label: "Coach", href: "/coach", icon: MessageSquare },
  { label: "Journal", href: "/journal", icon: Target },
  { label: "Dashboard", href: "/dashboard", icon: LayoutDashboard },
  { label: "Profile", href: "/dashboard?tab=settings", icon: User },
];

export default function BottomTabBar() {
  const location = useLocation();
  const { user } = useAuth();

  if (!user) return null;

  const isActive = (href: string) => {
    if (href === "/dashboard?tab=settings") {
      return location.pathname === "/dashboard" && location.search.includes("tab=settings");
    }
    if (href === "/dashboard") {
      return location.pathname === "/dashboard" && !location.search.includes("tab=settings");
    }
    return location.pathname === href;
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-xl border-t border-border/50 safe-area-bottom">
      <div className="flex items-center justify-around h-16 px-2">
        {tabs.map((tab) => {
          const active = isActive(tab.href);
          return (
            <Link
              key={tab.label}
              to={tab.href}
              state={(tab as any).state}
              className={`relative flex flex-col items-center justify-center gap-0.5 flex-1 py-2 min-h-[48px] transition-colors ${
                active ? "text-accent" : "text-muted-foreground"
              }`}
            >
              {active && (
                <motion.div
                  layoutId="tab-indicator"
                  className="absolute -top-px left-[25%] right-[25%] h-[2px] bg-accent rounded-full"
                  transition={{ type: "spring", bounce: 0.15, duration: 0.4 }}
                />
              )}
              <tab.icon size={20} strokeWidth={active ? 2.2 : 1.8} />
              <span className="text-[10px] font-medium tracking-wide">{tab.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
